// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.step-up-desc[data-v-2d105a32] {
  margin: 0 0 16px;
  font-size: 0.875rem;
  color: #333;
  line-height: 1.5;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
